<template>
    <div class="element-styling">
        <div class="main">
            <div class="container">
                <div id="app">
                    {{ message }}
                </div>
                <div class="section section-basic">
                    <div class="container">
                        <div class="title">
                            <h2>Basic Elements</h2>
                        </div>
                        <!--  buttons -->
                        <div id="buttons" class="cd-section">
                            <div class="title">
                                <h3>Buttons
                                    <br>
                                    <small>Pick your style</small>
                                </h3>
                            </div>
                            <div class="row">
                                <div class="col-md-8 ml-auto mr-auto">
                                    <button class="btn btn-primary">Default</button>
                                    <button class="btn btn-primary btn-round">Round</button>
                                    <button class="btn btn-primary btn-round">
                                        <i class="material-icons">favorite</i> With Icon
                                    </button>
                                    <button class="btn btn-primary btn-fab btn-round">
                                        <i class="material-icons">favorite</i>
                                    </button>
                                    <button class="btn btn-primary btn-link">Simple</button>
                                </div>
                            </div>
                            <div class="title">
                                <h3>
                                    <small>Pick your size</small>
                                </h3>
                            </div>
                            <div class="row">
                                <div class="col-md-8 ml-auto mr-auto">
                                    <button class="btn btn-primary btn-sm">Small</button>
                                    <button class="btn btn-primary">Regular</button>
                                    <button class="btn btn-primary btn-lg">Large</button>
                                </div>
                            </div>
                            <div class="title">
                                <h3>
                                    <small> Pick your color </small>
                                </h3>
                            </div>
                            <div class="row">
                                <div class="col-md-10 ml-auto">
                                    <button class="btn">Default</button>
                                    <button class="btn btn-primary">Primary</button>
                                    <button class="btn btn-info">Info</button>
                                    <button class="btn btn-success">Success</button>
                                    <button class="btn btn-warning">Warning</button>
                                    <button class="btn btn-danger">Danger</button>
                                    <button class="btn btn-rose">Rose</button>
                                </div>
                            </div>
                        </div>
                        <!--                 end buttons		         -->
                        <div class="space-50"></div>
                        <!--                 inputs -->
                        <div id="inputs">
                            <div class="title">
                                <h3>Inputs</h3>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 col-sm-4">
                                    <div class="form-group has-default">
                                        <input type="text" class="form-control" placeholder="Regular">
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-4">
                                    <div class="form-group">
                                        <label for="exampleInput1" class="bmd-label-floating">With Floating Label</label>
                                        <input type="email" class="form-control" id="exampleInput1">
                                        <span class="bmd-help">We'll never share your email with anyone else.</span>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-4">
                                    <div class="form-group has-success">
                                        <label for="exampleInput2" class="bmd-label-floating">Success input</label>
                                        <input type="text" class="form-control" id="exampleInput2">
                                        <span class="form-control-feedback">
                    <i class="material-icons">done</i>
                  </span>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-4">
                                    <div class="form-group has-danger">
                                        <label for="exampleInput3" class="bmd-label-floating">Error input</label>
                                        <input type="email" class="form-control" id="exampleInput3">
                                        <span class="form-control-feedback">
                    <i class="material-icons">clear</i>
                  </span>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-4">
                                    <div class="form-group">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">group</i>
                      </span>
                                            </div>
                                            <input type="text" class="form-control" placeholder="With Material Icons">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-4">
                                    <div class="form-group">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-group"></i>
                      </span>
                                            </div>
                                            <input type="text" class="form-control" placeholder="With Font Awesome Icons">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--                 end inputs -->
                        <div class="space-70"></div>
                        <!--                 textarea/checkbox/radio/toggle -->
                        <div id="checkRadios">
                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="title">
                                        <h3>Checkboxes</h3>
                                    </div>
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" value=""> Unchecked
                                            <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" value="" checked> Checked
                                            <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                    <div class="form-check disabled">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" value="" disabled> Disabled unchecked
                                            <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                    <div class="form-check disabled">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" value="" disabled checked> Disabled checked
                                            <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="title">
                                        <h3>Radio Buttons</h3>
                                    </div>
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1"> Radio is off
                                            <span class="circle">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2" checked> Radio is on
                                            <span class="circle">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                    <div class="form-check disabled">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="exampleRadios1" id="exampleRadios11" value="option1" disabled> Disabled radio is off
                                            <span class="circle">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                    <div class="form-check disabled">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="exampleRadio1" id="exampleRadios21" value="option2" checked disabled> Disabled radio is on
                                            <span class="circle">
                      <span class="check"></span>
                    </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="title">
                                        <h3>Toggle Buttons</h3>
                                    </div>
                                    <div class="togglebutton">
                                        <label>
                                            <input type="checkbox" checked="">
                                            <span class="toggle"></span>
                                            Toggle is on
                                        </label>
                                    </div>
                                    <div class="togglebutton">
                                        <label>
                                            <input type="checkbox">
                                            <span class="toggle"></span>
                                            Toggle is off
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="space-70"></div>
                        <!--    progress/sliders -->
                        <div id="progress">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="title">
                                        <h3>Progress Bars</h3>
                                    </div>
                                    <div class="progress progress-line-primary">
                                        <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 30%;">
                                            <span class="sr-only">60% Complete</span>
                                        </div>
                                    </div>
                                    <div class="progress progress-line-info">
                                        <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%;">
                                            <span class="sr-only">60% Complete</span>
                                        </div>
                                    </div>
                                    <div class="progress progress-line-danger">
                                        <div class="progress-bar progress-bar-success" style="width: 35%">
                                            <span class="sr-only">35% Complete (success)</span>
                                        </div>
                                        <div class="progress-bar progress-bar-warning" style="width: 20%">
                                            <span class="sr-only">20% Complete (warning)</span>
                                        </div>
                                        <div class="progress-bar progress-bar-danger" style="width: 10%">
                                            <span class="sr-only">10% Complete (danger)</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="title">
                                        <h3>Pagination</h3>
                                    </div>
                                    <ul class="pagination pagination-primary">
                                        <!--
                                                    color-classes: "pagination-primary", "pagination-info", "pagination-success", "pagination-warning", "pagination-danger"
                                                -->
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">1</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">...</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">5</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">6</a>
                                        </li>
                                        <li class="active page-item">
                                            <a href="javascript:void(0);" class="page-link">7</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">8</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">9</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">...</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">12</a>
                                        </li>
                                    </ul>
                                    <ul class="pagination pagination-info">
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link"> prev</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">1</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">2</a>
                                        </li>
                                        <li class="active page-item">
                                            <a href="javascript:void(0);" class="page-link">3</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">4</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">5</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="javascript:void(0);" class="page-link">next </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!--                 end progress -->
                        <!--                 sliders -->
                        <div id="sliders">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="title">
                                        <h3>Sliders</h3>
                                    </div>
                                    <div id="sliderRegular" class="slider"></div>
                                    <div id="sliderDouble" class="slider slider-info"></div>
                                </div>
                                <div class="col-md-6 ml-auto">
                                    <div class="title">
                                        <h3>Badges </h3>
                                    </div>
                                    <span class="badge badge-pill badge-secondary">Default</span>
                                    <span class="badge badge-pill badge-primary">Primary</span>
                                    <span class="badge badge-pill badge-info">Info</span>
                                    <span class="badge badge-pill badge-success">Success</span>
                                    <span class="badge badge-pill badge-warning">Warning</span>
                                    <span class="badge badge-pill badge-danger">Danger</span>
                                    <span class="badge badge-pill badge-rose">Rose</span>
                                </div>
                            </div>
                        </div>
                        <!--                 end sliders -->
                    </div>
                </div>
                <div class="section cd-section section-notifications" id="notifications">
                    <div class="container">
                        <div class="title">
                            <h3>Notifications</h3>
                        </div>
                    </div>
                    <div class="alert alert-info">
                        <div class="container">
                            <div class="alert-icon">
                                <i class="material-icons">info_outline</i>
                            </div>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true"><i class="material-icons">clear</i></span>
                            </button>
                            <b>Info alert:</b> You&apos;ve got some friends nearby, stop looking at your phone and find them...
                        </div>
                    </div>
                    <div class="alert alert-success">
                        <div class="container">
                            <div class="alert-icon">
                                <i class="material-icons">check</i>
                            </div>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true"><i class="material-icons">clear</i></span>
                            </button>
                            <b>Success Alert:</b> Yuhuuu! You&apos;ve got your $11.99 album from The Weeknd
                        </div>
                    </div>
                    <div class="alert alert-warning">
                        <div class="container">
                            <div class="alert-icon">
                                <i class="material-icons">warning</i>
                            </div>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true"><i class="material-icons">clear</i></span>
                            </button>
                            <b>Warning Alert:</b> Hey, it looks like you still have the &quot;copyright &#xA9; 2015&quot; in your footer. Please update it!
                        </div>
                    </div>
                    <div class="alert alert-danger">
                        <div class="container">
                            <div class="alert-icon">
                                <i class="material-icons">error_outline</i>
                            </div>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true"><i class="material-icons">clear</i></span>
                            </button>
                            <b>Error Alert:</b> Damn man! You screwed up the server this time. You should find a good excuse for your Boss...
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
                <div class="section">
                    <div class="container tim-container">
                        <!--     	        typography -->
                        <div id="typography" class="cd-section">
                            <div class="title">
                                <h2>Typography</h2>
                            </div>
                            <div class="row">
                                <div class="tim-typo">
                                    <h1>
                                        <span class="tim-note">Header 1</span>The Life of Material Kit </h1>
                                </div>
                                <div class="tim-typo">
                                    <h2>
                                        <span class="tim-note">Header 2</span>The Life of Material Kit</h2>
                                </div>
                                <div class="tim-typo">
                                    <h3>
                                        <span class="tim-note">Header 3</span>The Life of Material Kit</h3>
                                </div>
                                <div class="tim-typo">
                                    <h4>
                                        <span class="tim-note">Header 4</span>The Life of Material Kit</h4>
                                </div>
                                <div class="tim-typo">
                                    <h5>
                                        <span class="tim-note">Header 5</span>The Life of Material Kit</h5>
                                </div>
                                <div class="tim-typo">
                                    <h6>
                                        <span class="tim-note">Header 6</span>The Life of Material Kit</h6>
                                </div>
                                <div class="tim-typo">
                                    <h1 class="title">
                                        <span class="tim-note">Header 1 Title</span>The Life of Material Kit </h1>
                                </div>
                                <div class="tim-typo">
                                    <h2 class="title">
                                        <span class="tim-note">Header 2 Title</span>The Life of Material Kit</h2>
                                </div>
                                <div class="tim-typo">
                                    <h3 class="title">
                                        <span class="tim-note">Header 3 Title</span>The Life of Material Kit</h3>
                                </div>
                                <div class="tim-typo">
                                    <h4 class="title">
                                        <span class="tim-note">Header 4 Title</span>The Life of Material Kit</h4>
                                </div>
                                <div class="tim-typo">
                                    <p>
                                        <span class="tim-note">Paragraph</span>
                                        I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that&#x2019;s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.</p>
                                </div>
                                <div class="tim-typo">
                                    <span class="tim-note">Quote</span>
                                    <div class="blockquote undefined">
                                        <p>
                                            I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that&#x2019;s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.
                                        </p>
                                        <small>
                                            Kanye West, Musician
                                        </small>
                                    </div>
                                </div>
                                <div class="tim-typo">
                                    <span class="tim-note">Muted Text</span>
                                    <p class="text-muted">
                                        I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...
                                    </p>
                                </div>
                                <div class="tim-typo">
                                    <span class="tim-note">Primary Text</span>
                                    <p class="text-primary">
                                        I will be the leader of a company that ends up being worth billions of dollars, because I got the answers... </p>
                                </div>
                                <div class="tim-typo">
                                    <span class="tim-note">Info Text</span>
                                    <p class="text-info">
                                        I will be the leader of a company that ends up being worth billions of dollars, because I got the answers... </p>
                                </div>
                                <div class="tim-typo">
                                    <span class="tim-note">Success Text</span>
                                    <p class="text-success">
                                        I will be the leader of a company that ends up being worth billions of dollars, because I got the answers... </p>
                                </div>
                                <div class="tim-typo">
                                    <span class="tim-note">Warning Text</span>
                                    <p class="text-warning">
                                        I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...
                                    </p>
                                </div>
                                <div class="tim-typo">
                                    <span class="tim-note">Danger Text</span>
                                    <p class="text-danger">
                                        I will be the leader of a company that ends up being worth billions of dollars, because I got the answers... </p>
                                </div>
                                <div class="tim-typo">
                                    <h2>
                                        <span class="tim-note">Small Tag</span>
                                        Header with small subtitle
                                        <br>
                                        <small>Use &quot;small&quot; tag for the headers</small>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <!--                 end typography -->
                        <div class="space-50"></div>
                        <!--                 images -->
                        <div id="images">
                            <div class="title">
                                <h2>Images</h2>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-sm-2">
                                    <h4>Rounded Image</h4>
                                    <img src="styleguide/img/faces/avatar.jpg" alt="Rounded Image" class="rounded img-fluid">
                                </div>
                                <div class="col-sm-2 ml-auto">
                                    <h4>Circle Image</h4>
                                    <img src="styleguide/img/faces/avatar.jpg" alt="Circle Image" class="rounded-circle img-fluid">
                                </div>
                                <div class="col-sm-2 ml-auto">
                                    <h4>Rounded Raised</h4>
                                    <img src="styleguide/img/faces/avatar.jpg" alt="Raised Image" class="img-raised rounded img-fluid">
                                </div>
                                <div class="col-sm-2 ml-auto">
                                    <h4>Circle Raised</h4>
                                    <img src="styleguide/img/faces/avatar.jpg" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid">
                                </div>
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <!--                 end images	             -->
                        <div class="space-50"></div>
                    </div>
                </div></div>
            <div class="section cd-section" id="javascriptComponents">
                <div class="container">
                    <div class="title">
                        <h2>Javascript components</h2>
                    </div>
                    <!--                 modals -->
                    <div class="row" id="modals">
                        <div class="col-md-6">
                            <div class="title">
                                <h3>Modal</h3>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <button class="btn btn-block btn-primary" data-toggle="modal" data-target="#myModal">
                                        <i class="material-icons">library_books</i> Classic
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="title">
                                    <h3>Datetime Picker</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="label-control">Datetime Picker</label>
                                            <input type="text" class="form-control datetimepicker" value="10/05/2016">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="title">
                                <h3>Popovers</h3>
                            </div>
                            <button type="button" class="btn" data-toggle="popover" data-placement="left" title="Popover on left" data-content="Here will be some very useful information about his popover. Here will be some very useful information about his popover." data-container="body">On left</button>
                            <button type="button" class="btn" data-toggle="popover" data-placement="top" title="Popover on top" data-content="Here will be some very useful information about his popover." data-container="body">On top</button>
                            <button type="button" class="btn" data-toggle="popover" data-placement="bottom" title="Popover on bottom" data-content="Here will be some very useful information about his popover." data-container="body">On bottom</button>
                            <button type="button" class="btn" data-toggle="popover" data-placement="right" title="Popover on right" data-content="Here will be some very useful information about his popover." data-container="body">On right</button>
                            <br>
                            <br>
                            <div class="title">
                                <h3>Tooltips</h3>
                            </div>
                            <button type="button" class="btn" data-toggle="tooltip" data-placement="left" title="Tooltip on left" data-container="body">On left</button>
                            <button type="button" class="btn" data-toggle="tooltip" data-placement="top" title="Tooltip on top" data-container="body">On top</button>
                            <button type="button" class="btn" data-toggle="tooltip" data-placement="bottom" title="Tooltip on bottom" data-container="body">On bottom</button>
                            <button type="button" class="btn" data-toggle="tooltip" data-placement="right" title="Tooltip on right" data-container="body">On right</button>
                        </div>
                    </div>
                    <!--                 end modals	             -->
                    <div class="title">
                        <h3>Carousel</h3>
                    </div>
                </div>
            </div>
            <!--         carousel  -->
            <div class="section" id="carousel">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 mr-auto ml-auto">
                            <!-- Carousel Card -->
                            <div class="card card-raised card-carousel">
                                <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" data-interval="3000">
                                    <ol class="carousel-indicators">
                                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                    </ol>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img class="d-block w-100" src="styleguide/img/bg2.jpg" alt="First slide">
                                            <div class="carousel-caption d-none d-md-block">
                                                <h4>
                                                    <i class="material-icons">location_on</i> Yellowstone National Park, United States
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="carousel-item">
                                            <img class="d-block w-100" src="styleguide/img/bg3.jpg" alt="Second slide">
                                            <div class="carousel-caption d-none d-md-block">
                                                <h4>
                                                    <i class="material-icons">location_on</i> Somewhere Beyond, United States
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="carousel-item">
                                            <img class="d-block w-100" src="styleguide/img/bg.jpg" alt="Third slide">
                                            <div class="carousel-caption d-none d-md-block">
                                                <h4>
                                                    <i class="material-icons">location_on</i> Yellowstone National Park, United States
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                        <i class="material-icons">keyboard_arrow_left</i>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                        <i class="material-icons">keyboard_arrow_right</i>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </div>
                            </div>
                            <!-- End Carousel Card -->
                        </div>
                    </div>
                </div>
            </div>
            <!--         end carousel -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ElementStyling'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
